import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';

export const initTransparentHeader = () => {
  // Determine what is the first
  const body = document.querySelector(s.selectors$1c.body);
  const header = body.querySelector(s.selectors$1c.header);

  if (!header) return;

  const headerTransparent = header.getAttribute(a.attributes$M.transparent) === 'true';
  const firstSection = body.querySelector(s.selectors$1c.main).children[0];

  if (!firstSection) return;

  const preventTransparentHeader = firstSection.querySelector(
    `${s.selectors$1c.preventTransparentHeader}:first-of-type`
  );
  window.isHeaderTransparent =
    headerTransparent &&
    firstSection.classList.contains(c.classes$$.supportsTransparentHeader) &&
    !preventTransparentHeader;

  const supportsHasSelector = CSS.supports('(selector(:has(*)))');
  if (!supportsHasSelector) {
    body.classList.toggle(c.classes$$.isFirstSectionTransparent, window.isHeaderTransparent);
    header.classList.toggle(c.classes$$.siteHeaderTransparent, window.isHeaderTransparent);
  }
};